<template>
	<window-view title="Byggeleder" v-on="$listeners" :width="400" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<input-view v-model="m.name" label="Navn" />
				</grid-view>
				<grid-view :cols="['1fr', '1fr']">
					<input-view v-model="m.phone" label="Telefon" />
					<input-view v-model="m.email" label="E-mail" />
				</grid-view>
			</panel-sep-view>
			<panel-sep-view>
				<grid-view>
					<input-view v-model="m.password" label="Adgangskode" />
				</grid-view>
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import manager from '../../../model/manager';

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				m: manager.model()
			};
		},
		computed: {
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							return self.submit(this.m);
						}
					}
				];
			}
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};
		}
	}
</script>

<style lang="scss" scoped>

</style>